import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; //useNavigate
import swal from "sweetalert";
import Modal from "./childComponents/popups/Modal";
import Loading from "./childComponents/appComponents/Loading";
import InputField from "./childComponents/inputComponents/InputField";
import SelectField from "./childComponents/inputComponents/SelectField";
import { FaBan } from "react-icons/fa";
import { MdContentPasteSearch, MdDelete } from "react-icons/md";
import { FaRegNewspaper } from "react-icons/fa6";

const Faq = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const BUTTON_NAME = "Search FAQ"; // Submit Button Name

  const [filteredRecords, setFilteredRecords] = useState([]);

  const [publishedRecords, setPublishedRecords] = useState(0);
  const [draftRecords, setDraftRecords] = useState(0);
  const [trashRecords, setTrashRecords] = useState(0);
  const [btnColor, setBtnColor] = useState("primary");

  const [displayMessages, setDisplayMessages] = useState("");
  const [searchType, setSearchType] = useState("");

  const [allRecords, setAllRecords] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
  });

  //Fetches all Form Data
  const [formData, setFormData] = useState({
    input: {
      startDate: null,
      endDate: null,
      faq: null,
      faqAns: null,
      status: null,
    },
    button: {},
    select: {},
  });

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  // Reload Page
  const [reloadState, setReloadState] = useState({
    btnLoading: BUTTON_NAME,
    loading: true,
  });

  // Open Dialogue Box
  const [dialogueState, setDialogueState] = useState({
    modalType: false,
    modalTitle: null,
    trigger: false,
    editpost: null,
    searchScript: null,
  });

  //replaces each first character of a word with its uppercase version
  function ucwords(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  const [options, setOptions] = useState({
    tableSize: [
      { values: "10", item: "10" },
      { values: "20", item: "20" },
      { values: "50", item: "50" },
      { values: "100", item: "100" },
    ],
  });

  useEffect(() => {
    (async () => await fetchFaqData())();
    //(async () => await populateSelectMenu())();
  }, [dialogueState.editpost]);

  const searchDatabase = (event) => {
    event.preventDefault();
    const selectedType = event.currentTarget.dataset.value;

    setSearchType(selectedType); // still useful for UI display
    fetchFaqData(selectedType); // pass value directly
  };

  //Query constructor
  const queryConstructorString = (type = searchType) => {
    let query = "?";
    let messages = "";
    const initializeSearchDate = {};
    // Helper function to handle query string updates
    const addToQuery = (condition, Items, queryKey, value) => {
      if (condition === Items) {
        query += `${queryKey}[eq]=${value}&`;
        messages += `${condition.toUpperCase()}: Post | `;
      }
    };

    // Add query parameters dynamically
    addToQuery(type, "Published", "status02", "publish");
    addToQuery(type, "Draft", "status02", "draft");
    addToQuery(type, "Trash", "status02", "trash");

    const { input } = formData;
    //const timestampInSeconds = Math.floor(new Date("2025-06-01").getTime() / 1000);
    if (input.startDate) {
      query += `creationDate[gte]=${Math.floor(
        new Date(input.startDate).getTime() / 1000,
      )}&`;
      messages += `START DATE: ${input.startDate} | `;
      initializeSearchDate.startDate = input.startDate;
    }

    if (input.endDate) {
      query += `creationDate[lte]=${Math.floor(
        new Date(input.endDate).getTime() / 1000,
      )}&`;
      messages += `END DATE: ${input.endDate} | `;
      initializeSearchDate.endDate = input.endDate;
    }

    if (query === "?") {
      query += "status[eq]=publish";
    }

    return { query, messages, initializeSearchDate };
  };

  // Fetch All Registry Records
  const fetchFaqData = async (page = 1, customSearchType = searchType, customPerPage = perPage) => {
    const { query, messages, initializeSearchDate } =
      queryConstructorString(customSearchType);

    // Display Current Search Request Parameters as a Message
    setDisplayMessages(messages);

    // Store a sample of Current Search Request Parameters for Dialogue Box
    setDialogueState((prev) => ({
      ...prev,
      searchScript: query,
    }));

    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([
        axios.get(
          `${BASE_URL}faqdata${query}&page=${page}&per_page=${customPerPage}`,
        ),
        axios.get(`${BASE_URL}faqquantity`),
      ]);

      const [FaqData, populateNumbering] = responses;

      const records = FaqData?.data?.allData || [];

      if (records.length === 0) {
        swal(
          "Oops!",
          "Sorry! we did not find any information in the Post",
          "warning",
        );
        setReloadState({
          btnLoading: BUTTON_NAME,
          loading: false,
        });
      } else {
        setDialogueState((prev) => ({
          ...prev,
          searchDates: initializeSearchDate,
        }));

        setAllRecords(records);
setFilteredRecords(records);
        setPagination(
          FaqData.data.pagination || {
            current_page: 1,
            last_page: 1,
            per_page: 10,
            total: 0,
          },
        );

        setReloadState({
          btnLoading: BUTTON_NAME,
          loading: false,
        });
      }

      populateNumbering.data.publish &&
        setPublishedRecords(populateNumbering.data.publish);
      populateNumbering.data.draft &&
        setDraftRecords(populateNumbering.data.draft);
      populateNumbering.data.trash &&
        setTrashRecords(populateNumbering.data.trash);
    } catch (error) {
      swal("Error", "Error fetching Registry Data", "error");
      console.log("Error fetching Registry Data:", error);
    }
  };

  // Pagination
  const getPaginationRange = () => {
    const total = pagination.last_page;
    const current = pagination.current_page;

    const delta = 1; // how many pages around current

    const range = [];
    const rangeStart = Math.max(2, current - delta);
    const rangeEnd = Math.min(total - 1, current + delta);

    range.push(1);

    if (rangeStart > 2) {
      range.push("...");
    }

    for (let i = rangeStart; i <= rangeEnd; i++) {
      range.push(i);
    }

    if (rangeEnd < total - 1) {
      range.push("...");
    }

    if (total > 1) {
      range.push(total);
    }

    return range;
  };

  const changePage = (page) => {
    if (page >= 1 && page <= pagination.last_page) {
      fetchFaqData(page);
    }
  };

  const pages = getPaginationRange();

  // Search
  async function searchData(event) {
    event.preventDefault();
    setReloadState((prev) => ({
      ...prev,
      btnLoading: <div>Processsing...</div>,
    }));
    fetchFaqData();
  }

  // const handleFilter = (event) => {
  //   let text = event.target.value;

  //   let newData = filteredRecords.filter(
  //     (row) =>
  //       row.faq.toLowerCase().includes(text.toLowerCase()) ||
  //       row.faqAns.toLowerCase().includes(text.toLowerCase())
  //   );
  //   if (event) {
  //     setAllRecords(newData.length > 0 ? newData : allRecords);
  //   }
  // };

  const handleFilter = (event) => {
    const text = event.target.value.toLowerCase();

    const newData = filteredRecords.filter(
      (row) =>
        (row.faq ?? "").toLowerCase().includes(text) ||
        (row.faqAns ?? "").toLowerCase().includes(text),
    );

    setAllRecords(newData.length > 0 ? newData : allRecords);
  };

  // Open Dialogue Box for Update
  async function updateData(event, posts) {
    event.preventDefault();

    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalFaq",
      modalTitle: "EDIT FAQ",
      trigger: true,
      editpost: posts,
    }));
    setBtnColor("success");
  }

  // Open Dialogue Box for Draft
  async function draftData(event, id) {
    event.preventDefault();

    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    const draftItem = async () => {
      await axios.get("sanctum/csrf-cookie").then((response) => {
        axios.delete(`${BASE_URL}faqdata/draft/${id}`).then((res) => {
          if (res?.data?.status === 200) {
            formCleanner();
            swal("Drafted", res.data.message, "success");
          } else {
            swal("Oops!", res.data.message, "warning");
          }
        });
      });
    };

    await swal({
      title: "Are you sureee!!?",
      text: "Once set to draft, you will have to  publish to recover this data againoo!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        (async () => await draftItem())();
      } else {
        swal("Saved", "The data is safe!", "success");
      }
    });
  }

  // Open Dialogue Box for Fresh Post
  async function addData() {
    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    const initializeEditposts = {
      faq: "",
      faqAns: "",
      status: "",
      creationDate: "",
    };

    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalFaq",
      modalTitle: "POST FAQ",
      trigger: true,
      editpost: initializeEditposts,
    }));
    setBtnColor("primary");
  }

  // Delete a Row of Data
  async function DeletePost(event, id) {
    event.preventDefault();

    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    const deleteItem = async () => {
      await axios.get("sanctum/csrf-cookie").then((response) => {
        axios.delete(`${BASE_URL}faqdata/${id}`).then((res) => {
          if (res?.data?.status === 200) {
            formCleanner();
            swal("Deleted", res.data.message, "success");
          } else {
            swal("Oops!", res.data.message, "warning");
          }
        });
      });
    };

    await swal({
      title: "Are you sureee!!?",
      text: "Once deleted, you will not be able to recover this data againoo!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        (async () => await deleteItem())();
      } else {
        swal("Saved", "The data is safe!", "success");
      }
    });
  }

  // Open Dialogue Box for Printing Registry
  async function printFaq() {
    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalFaqPrintout",
      modalTitle: "FAQ DETAILS",
      trigger: true,
      editpost: allRecords,
    }));

    setReloadState((prev) => ({
      ...prev,
      btnLoading: <div>Processsing...</div>,
    }));
  }

  // Clean the Form
  const formCleanner = () => {
    setDialogueState((prev) => ({
      ...prev,
      modalType: false,
      modalTitle: null,
      trigger: false,
      editpost: null,
      searchScript: null,
    }));

    fetchFaqData();
  };

  if (reloadState.loading) {
    return <Loading message01={"Loading..."} />;
  }
  function softreload() {
    window.location.reload();
  }

  return (
    <>
      {/* modal Type, Title of the Modal Box, triger the modal, convay all the data inputs to be edithed to child */}
      <Modal
        modalType={dialogueState.modalType}
        titles={dialogueState.modalTitle}
        trigger={dialogueState.trigger}
        editpost={dialogueState.editpost}
        formCleanner={formCleanner}
        searchDate={dialogueState.searchDates}
        searchScript={dialogueState.searchScript}
        btnColor={btnColor}
      />

      <div className="container-lg-fluid m-3">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card">
              <div className="card-header text-white bg-success p-3">
                <i className="fa fa-search"></i> SEARCH FAQ
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <div className="col-lg-12 row">
                    <Link
                      to=""
                      className="col-lg-2 pt-4"
                      onClick={searchDatabase}
                      data-value="Published"
                      style={{ fontSize: "16px" }}
                    >
                      <div className="col-12 border-end">
                        <FaRegNewspaper style={{ fontSize: "20px" }} />{" "}
                        Published ({publishedRecords})
                      </div>
                    </Link>

                    <Link
                      to=""
                      className="col-lg-2 pt-4"
                      onClick={searchDatabase}
                      data-value="Draft"
                      style={{ fontSize: "16px" }}
                    >
                      <div className="col-12 border-end">
                        <FaBan style={{ fontSize: "20px" }} /> Draft (
                        {draftRecords})
                      </div>
                    </Link>

                    <Link
                      to=""
                      className="col-lg-2 pt-4"
                      onClick={searchDatabase}
                      data-value="Trash"
                      style={{ fontSize: "16px" }}
                    >
                      <div className="col-12">
                        <MdDelete style={{ fontSize: "20px" }} /> Trash (
                        {trashRecords})
                      </div>
                    </Link>

                    <div className="col-lg-2">
                      <Link
                        className="btn btn-success col-12 mt-4"
                        onClick={softreload}
                        to="/admin/faq"
                      >
                        <i className="fa fa-refresh"></i>
                      </Link>
                    </div>

                    <div className="col-lg-2">
                      <button
                        className="btn btn-danger col-12 mt-4"
                        onClick={printFaq}
                        data-toggle="modal"
                        data-target="#exampleModal"
                        disabled
                      >
                        <div className="d-flex justify-content-center">
                          <i className="fa fa-print pt-1 pe-2"></i>
                          Print Document
                        </div>
                      </button>
                    </div>

                    <div className="col-lg-2">
                      <button
                        className="btn btn-primary col-12 mt-4"
                        onClick={addData}
                        data-toggle="modal"
                        data-target="#exampleModal"
                      >
                        <div className=" d-flex justify-content-center">
                          <i className="fa fa-plus-square-o pt-1 pe-2"></i>
                          Add FAQ
                        </div>
                      </button>
                    </div>
                  </div>

                  <div className="col-lg-12 mt-4 row">
                    <InputField
                      label="Start Date"
                      name="startDate"
                      size="2"
                      placeholder="Please Select Start Date"
                      required=""
                      value={formData.input.startDate}
                      type="date"
                      onChange={updateFormData}
                      icon="fa fa-calendar-check-o"
                    />

                    <InputField
                      label="End Date"
                      name="endDate"
                      size="2"
                      placeholder="Please Select End Date"
                      required=""
                      value={formData.input.endDate}
                      type="date"
                      onChange={updateFormData}
                      icon="fa fa-calendar-check-o"
                    />

                    <SelectField
                      label="Table Size"
                      name="tableSize"
                      size="2"
                      placeholder="Select a Table Size"
                      required="required"
                      value={perPage}
                      options={options.tableSize}
                      switchOptions={1}
                      type="text"
                      onChange={(type, key, value) => {
                        setPerPage(value);
                        fetchFaqData(1, searchType, value);
                      }}
                      icon="fa fa-columns"
                    />

                    <div className="col-lg-2">
                      <button
                        className="btn btn-success col-12 mt-4"
                        onClick={searchData}
                      >
                        <div className=" d-flex justify-content-center">
                          <i className="fa fa-search pt-1 pe-2"></i>
                          {reloadState.btnLoading}
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-lg-fluid m-3">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card">
              <div className="card-header text-white bg-success p-3">
                <MdContentPasteSearch style={{ fontSize: "20px" }} /> FAQ's
                Dashboard
                <span className="float-end me-3">{displayMessages}</span>
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <div>
                    <div style={{ display: "flex", float: "right" }}>
                      <input
                        type="text"
                        name="searchData"
                        placeholder="Search Quetions or Answers."
                        style={{ padding: "5px 7px" }}
                        onChange={handleFilter}
                      />
                    </div>
                  </div>
                  <div style={{ width: "100%", overflowX: "scroll" }}>
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col" style={{ width: "5%" }}>
                            Select
                          </th>
                          {[
                            "Action",
                            "FAQ's",
                            "FAQ's Answers",
                            "Visibility",
                            "Published Date",
                          ].map((items, index) => (
                            <th key={index} scope="col">
                              {items}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {allRecords.map((allRecord, index) => {
                          const date = new Date(allRecord.creationDate * 1000);
                          const formatted = date.toISOString().split("T")[0];
                          return (
                            <tr key={index}>
                              <th scope="row">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  name={allRecord.id}
                                />
                              </th>
                              <td style={{ width: "20%" }}>
                                <button
                                  type="button"
                                  className="btn btn-success me-3"
                                  data-toggle="modal"
                                  data-target="#exampleModal"
                                  onClick={(event) =>
                                    updateData(event, allRecord)
                                  }
                                >
                                  <i className="fa fa-edit me-1"> </i>
                                  Edit
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-secondary me-3"
                                  data-toggle="modal"
                                  data-target="#exampleModal"
                                  onClick={(event) =>
                                    draftData(event, allRecord.id)
                                  }
                                >
                                  <i className="fa fa-ban me-1"> </i>
                                  Draft
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-danger"
                                  onClick={(event) =>
                                    DeletePost(event, allRecord.id)
                                  }
                                >
                                  <i className="fa fa-trash me-1"> </i>
                                  Trash
                                </button>
                              </td>

                              <td style={{ width: "20%" }}>{allRecord.faq}</td>
                              <td style={{ width: "35%" }}>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: allRecord.faqAns,
                                  }}
                                />
                              </td>
                              <td style={{ width: "10%" }}>
                                {ucwords(allRecord.visibility)}
                              </td>
                              <td style={{ width: "10%" }}>{formatted}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  <nav>
                    <ul className="pagination">
                      {/* Prev */}
                      <li
                        className={`page-item ${pagination.current_page === 1 ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            changePage(pagination.current_page - 1)
                          }
                        >
                          Prev
                        </button>
                      </li>

                      {/* Pages */}
                      {pages.map((page, index) => (
                        <li
                          key={index}
                          className={`page-item ${
                            page === pagination.current_page ? "active" : ""
                          } ${page === "..." ? "disabled" : ""}`}
                        >
                          <button
                            className="page-link"
                            onClick={() => page !== "..." && changePage(page)}
                          >
                            {page}
                          </button>
                        </li>
                      ))}

                      {/* Next */}
                      <li
                        className={`page-item ${pagination.current_page === pagination.last_page ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            changePage(pagination.current_page + 1)
                          }
                        >
                          Next
                        </button>
                      </li>

                      <li className="page-item ps-3 pe-3 pt-1 bg-primary text-white">
                        Total: {pagination.total}
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faq;
